/* 🤖 this file was generated by svg-to-ts */
export const DfIconMagnifyingGlass16: {
  name: 'magnifying-glass-16';
  data: string;
} = {
  name: 'magnifying-glass-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m10.968 9.365 4.325 3.363a1.83 1.83 0 0 1 .172 2.738 1.827 1.827 0 0 1-2.735-.17l-3.365-4.328a6 6 0 1 1 1.603-1.603zM6 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" fill-rule="evenodd"/></svg>`
};
